import React from 'react';
import AlternativeTemplate from './templates/AlternativeTemplate';
import { buildAlternative } from './config/alternatives';

const cfg = buildAlternative('lexoffice');
export default function LexofficeAlternative() { return <AlternativeTemplate cfg={cfg} />; }
